import React from 'react';
import { useFela } from 'react-fela';
import { Text } from '../common';

const contentRules = () => ({
  maxWidth: '360px',
  textAlign: 'center',
});

const containerRules = ({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.color.overlayDarkHeavy,
  bottom: '0',
  color: theme.color.light,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  left: '0',
  position: 'absolute',
  right: '0',
  top: '0',
});

export default function PauseOverlay() {
  const { css } = useFela();
  return (
    <div className={css(containerRules)}>
      <p className={css(contentRules)}>
        <Text id="playerOverlays.pauseOverlay" />
      </p>
    </div>
  );
}
